<script>
import { cmsMenuProps } from "./mixin";
import CmsMenuLayer from "./cms-menu-layer/mobile";
import List from "@/components/molecules/list";
import ListItemNavigation from "@/components/molecules/list-item-navigation";
import Titre from "@/components/atoms/titre";
import LinkTo from "@/components/atoms/link-to";
import ButtonIcon from "@/components/molecules/button-icon";
import Divider from "@/components/atoms/divider";

export default {
  name: "CmsMenuMobile",
  components: {
    List,
    ListItemNavigation,
    Titre,
    LinkTo,
    ButtonIcon,
    CmsMenuLayer,
    Divider
  },
  props: {
    ...cmsMenuProps()
  },
  data() {
    return {
      menuNavigation: [this.category]
    };
  },
  computed: {
    isFinal() {
      return this.menuNavigation.length === 3;
    },
    canGoBack() {
      return this.menuNavigation.length > 1;
    },
    currentCategory() {
      return this.menuNavigation[this.menuNavigation.length - 1];
    },
    currentCategoryLabel() {
      return this.currentCategory && this.currentCategory.attributes
        ? this.currentCategory.attributes.libelle
        : "";
    }
  },
  methods: {
    showChild(child) {
      this.menuNavigation.push(child);
    },
    showParent(child) {
      this.menuNavigation.pop();
    }
  }
};
</script>

<template>
  <div class="c-cms-menu">
    <template v-if="canGoBack">
      <ButtonIcon
        v-if="currentCategoryLabel"
        icon-name="arrow-left"
        icon-color="white"
        icon-position="abs-left"
        icon-size="md"
        full-width
        variant="primary-light"
        class="c-cms-menu__title c-cms-menu__title--btn"
        @click="showParent()"
      >
        {{ currentCategoryLabel }}
      </ButtonIcon>
    </template>
    <template v-else>
      <Titre
        class="c-cms-menu__title"
        tag="h1"
        variant="white"
        size="md"
      >
        Menu des services et informations
      </Titre>
    </template>

    <div class="c-cms-menu__content">
      <template v-if="!canGoBack">
        <div
          v-for="(item, index) in menu"
          :key="`cms-menu-${index}`"
        >
          <template v-if="item.attributes && item.attributes.children && item.attributes.children.data && item.attributes.children.data.length > 0">
            <Titre
              tag="p"
              variant="primary"
              size="md"
            >
              {{ item.attributes.libelle }}
            </Titre>
            <List>
              <template
                v-for="(child, childIndex) in item.attributes.children.data"
                :key="`cms-menu-layer-${childIndex}`"
              >
                <template v-if="child.attributes.libelle">
                  <template v-if="child.attributes && child.attributes.children && child.attributes.children.data && child.attributes.children.data.length > 0">
                    <ListItemNavigation
                      no-border
                      class="c-cms-menu__item"
                      @click="showChild(child)"
                    >
                      {{ child.attributes.libelle }}
                    </ListItemNavigation>
                  </template>
                  <template v-else>
                    <ListItemNavigation
                      no-border
                      :to="child.attributes.slug"
                      class="c-cms-menu__item"
                    >
                      {{ child.attributes.libelle }}
                    </ListItemNavigation>
                  </template>
                </template>
              </template>
            </List>
          </template>
          <ListItemNavigation
            v-else
            :key="`cms-menu-layer-${item.id}`"
            no-border
            :to="item.attributes.slug"
            class="c-cms-menu__item"
          >
            <Titre
              tag="p"
              variant="primary"
              size="md"
              :to="item.attributes.slug"
            >
              {{ item.attributes.libelle }}
            </Titre>
          </ListItemNavigation>
        </div>
        <div class="u-mt-md">
          <LinkTo
            to="/infos-et-services/aide/faq"
            no-underline
          >
            Foire aux questions
          </LinkTo>
          <br>
          <LinkTo
            to="/infos-et-services/aide/contactez-nous"
            no-underline
            class="u-mt-sm"
          >
            Contactez-nous
          </LinkTo>
        </div>
        <Divider />
        <div class="c-cms-menu__item-button">
          <LinkTo
            v-if="hasLocationCora"
            class="c-cms-menu__item-button--external"
            :href="`https://${webAlias}.location.cora.fr`"
            no-underline
            target="_blank"
          >
            Cora Location
          </LinkTo>
          <br v-if="hasLocationCora">
          <LinkTo
            class="c-cms-menu__item-button--external"
            href="http://coraphotos.fr"
            no-underline
            target="_blank"
          >
            Photos
          </LinkTo>
          <br>
          <LinkTo
            class="c-cms-menu__item-button--external"
            href="https://spectacles.carrefour.fr/fr"
            no-underline
            target="_blank"
          >
            Carrefour Spectacles
          </LinkTo>
          <br>
          <LinkTo
            class="c-cms-menu__item-button--external"
            href="https://www.prime-energie-cora.fr"
            no-underline
            target="_blank"
          >
            Prime énergie
          </LinkTo>
          <br>
          <LinkTo
            class="c-cms-menu__item-button--external"
            href="https://numerisation.carrefour.fr/fr/accueil"
            no-underline
            target="_blank"
          >
            Numérisation
          </LinkTo>
        </div>
      </template>
      <template v-else>
        <CmsMenuLayer
          :category="currentCategory"
          @show="showChild"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-cms-menu {
  background: color(white);
}
.c-cms-menu__item {
  display: flex;
  border-bottom: 1px solid color(grey-5);
  &:first-child {
    border-top: 1px solid color(grey-5);
    margin-top: spacing(sm);
  }
  &:last-child {
    margin-bottom: spacing(md);
  }
}

.c-cms-menu__item--no-border {
  border: none;
}

.c-cms-menu__item-button {
  text-align: left;
  padding: 0.8rem 1rem 0.8rem 0;
  position: relative;
  width: 100%;
  min-height: 5rem;
  &:hover {
    color: color(primary-light);
  }
}

.c-cms-menu__item-button--external {
  position: relative;
  padding-right: 4rem;
  font-size: 1.5rem;
  color: color(text-light);
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0;
  font-weight: 400;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  &:after {
    content: "";
    width: 2.4rem;
    height: 2.4rem;
    position: absolute;
    right: 1.6rem;
    top: 50%;
    transform: translateY(-50%);
    background-image: url("@/assets/icons/external.svg");
    filter: invert(40%) sepia(1%) saturate(0%) hue-rotate(115deg)
      brightness(99%) contrast(87%);
    /*
    * Couleur : text-light;
    * Outil pour générer le filter : https://codepen.io/sosuke/pen/Pjoqqp
    */
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 2.4rem;
  }
  &:hover {
    color: color(primary-light);
    &:after {
      filter: invert(69%) sepia(97%) saturate(1807%) hue-rotate(176deg)
        brightness(92%) contrast(90%);
      /*
      * Couleur : primary-light;
      * Outil pour générer le filter : https://codepen.io/sosuke/pen/Pjoqqp
      */
    }
  }
}

.c-cms-menu__content {
  padding: spacing(sm);
}

.c-cms-menu__title {
  padding: spacing(sm);
  text-align: center;
  background-color: color(primary-light);
  color: color(white);
  font-size: fontSize(19);
  font-weight: 700;
  font-family: font(secondary);
}
.c-cms-menu__title--btn {
  display: flex;
  align-items: center;
  height: 5.6rem;
}
</style>
